import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import './i18n'; 
import Ga4Provider from './Ga4Provider';
import AnalyticsListener from "./AnalyticsListener";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Ga4Provider />
        <AnalyticsListener />
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
serviceWorkerRegistration.register();
reportWebVitals();